import { calculatorTool } from "./calculator"
import { captureTools } from "./capture"
import { noteIndex, noteTools } from "./notes"
import { referenceTools } from "./reference"
import { transitionByName, transitionTools } from "./transition"

export { generateTool } from "./generate"
export { pdfTool } from "./pdf"
export { searchTool } from "./search"
export { noteIndex, transitionByName }

// Everything an ai item offers the model from the core: what it declares, plus what the caller lends to the turn.
// search, generate and pdf are left to the adapter
export function itemTools(item: PlaybookItem, itemScope: string, lent: PlaybookTool[] = []): PlaybookTool[] {
  const has = (type: PlaybookToolConfig["type"]) => item.tools?.some(t => t.type === type)
  const tools = [...transitionTools(item), ...referenceTools(item), ...captureTools(item)]
  if (has("notes")) tools.push(...noteTools(itemScope))
  if (has("calculator")) tools.push(calculatorTool)
  return [...tools, ...lent]
}
